$(document).ready(function(){

    function showLoader() {
      $('#body-loader').show();
    }
    function hideLoader() {
      $('#body-loader').hide();
    } 


    function disableQuantityButtons() {
        const cartItem = $('[eq-cart__item]');
        if(cartItem.length > 0) {
            cartItem.each(function () {
                var $input = $(this).find('input.quantity__input');
                if ($input.length === 0) return;
                var quantity = parseInt($input.val()) || 1;
                var min = parseInt($input.attr('data-min')) || 1;
                var max = parseInt($input.attr('max')) || 9999;
    
                $(this).find('[name="minus"]').prop('disabled', quantity <= min);
                $(this).find('[name="plus"]').prop('disabled', quantity >= max);
            });
        }
    }

    function updateCartView() {
      showLoader();
        $.get(routes.cart_url, function (data) {
            var html = $(data).find('[data-cart-content]').html();
            if($('[data-cart-content]').length > 0) {
              $('[data-cart-content]').html(html);
            }
            if($('[data-cartDrawer-content]').length > 0) {
              $('[data-cartDrawer-content]').html($(data).find('[data-cartDrawer-content]').html());
            }
            if($('.header__cart').length > 0) {
              $('.header__cart').html($(data).find('.header__cart').html());
            }
            let cartBestProductSlider = $('.js-cart-best-product-slider');

            if(cartBestProductSlider.length > 0){
              cartBestProductSlider.each(function () {
                  let currentCartBestProductSlider = $(this);

                  if (!currentCartBestProductSlider.hasClass('slick-initialized')) {
                      let sliderWrap = currentCartBestProductSlider.closest('.eq-cart__product');
                      let arrowsWrap = sliderWrap.find('.js-cart-arrow');
              
                      // Move arrows into header-right if needed
                      if (arrowsWrap.length > 0) {
                          sliderWrap.find('.eq-cart__product-header-right').append(arrowsWrap);
                      }
              
                      currentCartBestProductSlider.slick({
                          arrows: false,
                          infinite: false,
                          slidesToShow: parseFloat($(currentCartBestProductSlider).attr('data-slide-desktop'), 10),
                          slidesToScroll: 1,
                          responsive: [
                              {
                                  breakpoint: 992,
                                  settings: {
                                      slidesToShow: parseFloat($(currentCartBestProductSlider).attr('data-slide-tab'), 10),
                                  }
                              },
                              {
                                  breakpoint: 768,
                                  settings: {
                                      slidesToShow: parseFloat($(currentCartBestProductSlider).attr('data-slide-mobile'), 10),
                                  }
                              }
                          ]
                      });
              
                      let $prevArrow = sliderWrap.find('.js-cart-prev-arrow');
                      let $nextArrow = sliderWrap.find('.js-cart-next-arrow');
              
                      if ($prevArrow.length > 0) {
                          $prevArrow.on('click', function () {
                              currentCartBestProductSlider.slick('slickPrev');
                              updateCartArrowState(currentCartBestProductSlider);
                          });
                      }
              
                      if ($nextArrow.length > 0) {
                          $nextArrow.on('click', function () {
                              currentCartBestProductSlider.slick('slickNext');
                              updateCartArrowState(currentCartBestProductSlider);
                          });
                      }
              
                      currentCartBestProductSlider.on('afterChange', function () {
                          updateCartArrowState(currentCartBestProductSlider);
                      });
              
                      updateCartArrowState(currentCartBestProductSlider);
                  }
              });
            }
            
            disableQuantityButtons();  
        }).always(hideLoader);
    }

    $('body').on('click', '[data-eq-cart__item-btn]', function () {
        var $input = $(this).siblings('input.quantity__input');
        if ($input.length === 0) return;
        var key = $input.data('key');
        var quantity = parseInt($input.val()) || 1;

        var min = parseInt($input.attr('data-min')) || 1;
        var max = parseInt($input.attr('max')) || 99999;
        var step = parseInt($input.attr('step')) || 1;

        if ($(this).attr("name") === 'plus') {
            if (quantity + step <= max) {
                quantity += step;
            } else {
                quantity = max;
            }
        } else if ($(this).attr("name") === 'minus') {
            if (quantity - step >= min) {
                quantity -= step;
            } else {
                quantity = min;
            }
        }

        showLoader();
        $.ajax({
            type: 'POST',
            url: '/cart/change.js',
            data: JSON.stringify({ id: key, quantity: quantity }),
            dataType: 'json',
            contentType: 'application/json',
            success: function () {
                updateCartView();
            },
            error: function () {
              hideLoader(); 
            }
        });
    });

    $('body').on('click', '[eq-cart__item-remove]', function (e) {
        e.preventDefault();

        const $item = $(this).closest('[data-key]');
        if (!$item.length) return;

        const key = $item.data('key');
        if (!key) return;

        showLoader();
        $.ajax({
            type: 'POST',
            url: '/cart/change.js',
            data: JSON.stringify({ id: key, quantity: 0 }),
            dataType: 'json',
            contentType: 'application/json',
            success: function () {
              updateCartView();
            },
            error: function () {
              hideLoader(); 
            }
        });
    });


    $('body').on('click', '[data-add-upsell-cart]', function (e) {
      e.preventDefault();

      var $form = $(this).closest('form');
      if (!$form.length) return;

      var formData = $form.serialize();
      if (!formData) return;

      showLoader();

      $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        data: formData,
        dataType: 'json',
        success: function (response) {
          updateCartView();
        },
        error: function () {
          hideLoader(); 
        }
      });
    });


});


  class ShippingEstimator extends HTMLElement {
  constructor() {
    super();
    this.handleEstimateShipping = this.handleEstimateShipping.bind(this);
  }

  connectedCallback() {
    this.submitButton = this.querySelector('[type="button"]');
    this.resultsElement = this.querySelector('[aria-live="polite"]');
    this.submitButton.addEventListener('click', this.handleEstimateShipping);
  }

  disconnectedCallback() {
    this.submitButton.removeEventListener('click', this.handleEstimateShipping);
  }

  async handleEstimateShipping(event) {
    event.preventDefault();

    const zip = this.querySelector('[name="address[zip]"]').value;
    const country = this.querySelector('[name="address[country]"]').value;
    const province = this.querySelector('[name="address[province]"]').value;


    const prepareResponse = await fetch(
      `${Shopify.routes.root}cart/prepare_shipping_rates.json?shipping_address[zip]=${zip}&shipping_address[country]=${country}&shipping_address[province]=${province}`,
      { method: 'POST' }
    );


    if (prepareResponse.ok) {
      const shippingRates = await this.getAsyncShippingRates(zip, country, province);
      this.renderShippingRates(shippingRates);
    } else {
      const jsonError = await prepareResponse.json();
      this.renderError(jsonError);
    }

    this.resultsElement.hidden = false;
  }

  async getAsyncShippingRates(zip, country, province) {
    const response = await fetch(
      `${Shopify.routes.root}cart/async_shipping_rates.json?shipping_address[zip]=${zip}&shipping_address[country]=${country}&shipping_address[province]=${province}`
    );
    const responseText = await response.text();

    if (responseText === 'null') {
      return this.getAsyncShippingRates(zip, country, province);
    }

    const json = JSON.parse(responseText);
    return json.shipping_rates || [];
  }

  renderShippingRates(rates) {
    const rateItems = rates.map((rate) => {
      const formattedPrice = new Intl.NumberFormat('en-IN', {
        style: 'currency',
        currency: rate.currency
      }).format(rate.price);
      return `<li>${rate.presentment_name}: ${formattedPrice}</li>`;
    }).join('');

    const message =
      rates.length === 0
        ? window.themeVariables.strings.shippingEstimatorNoResults
        : rates.length === 1
        ? window.themeVariables.strings.shippingEstimatorOneResult
        : window.themeVariables.strings.shippingEstimatorMultipleResults;

    this.resultsElement.innerHTML = `
      <div class="rate_result">
        <p>${message}</p>
        ${rateItems ? `<ul class="list-disc" role="list">${rateItems}</ul>` : ''}
      </div>
    `;
  }

  renderError(errors) {
    const errorItems = Object.values(errors).map((msg) => `<li>${msg}</li>`).join('');

    this.resultsElement.innerHTML = `
      <div class="rate_result">
        <p>${window.themeVariables.strings.shippingEstimatorError}</p>
        <ul class="list-disc" role="list">${errorItems}</ul>
      </div>
    `;
  }
}

if (!window.customElements.get('shipping-estimator')) {
  window.customElements.define('shipping-estimator', ShippingEstimator);
}



class CountrySelector extends HTMLElement {
  constructor() {
    super();
    this.handleCountryChange = this.handleCountryChange.bind(this);
  }

  connectedCallback() {
    this.countryElement = this.querySelector('[name="address[country]"]');
    this.provinceElement = this.querySelector('[name="address[province]"]');

    this.countryElement.addEventListener("change", this.handleCountryChange);

    if (this.hasAttribute("country") && this.getAttribute("country") !== "") {
      const countryName = this.getAttribute("country");
      const index = Array.from(this.countryElement.options).findIndex(
        (option) => option.textContent === countryName
      );
      this.countryElement.selectedIndex = Math.max(0, index);
    }

    this.countryElement.dispatchEvent(new Event("change"));
  }

  disconnectedCallback() {
    this.countryElement.removeEventListener("change", this.handleCountryChange);
  }

  handleCountryChange() {
    const selectedOption = this.countryElement.options[this.countryElement.selectedIndex];
    const provinces = JSON.parse(selectedOption.getAttribute("data-provinces"));

    console.log(this.provinceElement, this.countryElement, " sssss");

    const provinceWrapper = this.provinceElement.parentElement;
    provinceWrapper.hidden = provinces.length === 0;

    if (provinces.length > 0) {
      this.provinceElement.innerHTML = "";

      const selectedProvinceAttr = this.getAttribute("province");

      provinces.forEach(([value, label]) => {
        const isSelected = selectedProvinceAttr === value || selectedProvinceAttr === label;
        this.provinceElement.options.add(new Option(label, value, isSelected, isSelected));
      });
    }
  }
}

if (!window.customElements.get("country-selector")) {
  window.customElements.define("country-selector", CountrySelector);
}
